import React from "react";

const API = process.env.REACT_APP_BACKEND_URL;
const VERSION = "2";

export default function OAAssessmentPage() {
  return (
    <iframe
      src={`${API}/api/static/oa-assessment-mh?v=${VERSION}`}
      title="Solar OA Calculator for Maharashtra"
      data-testid="oa-assessment-iframe"
      style={{ width: "100%", height: "100vh", border: "none", display: "block" }}
    />
  );
}
